import { Link } from 'react-router-dom';
import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { sectors } from '@/mocks/site';

export default function Sectors() {
  return (
    <section className="relative overflow-hidden bg-background-100 py-20 md:py-28">
      <div className="pointer-events-none absolute inset-0 paper-grid opacity-60" />
      <div className="container-wide relative">
        <div className="grid gap-12 lg:grid-cols-[0.85fr_1.15fr] lg:gap-20">
          <div className="lg:sticky lg:top-32 lg:self-start">
            <Reveal>
              <SectionHeading
                label="Secteurs desservis"
                title={
                  <>
                    Nous intervenons
                    <br />
                    là où la marge
                    <br />
                    d'erreur est nulle
                  </>
                }
                description="Nos équipes travaillent pour des sites de production, des ports, des cimenteries et des unités agro-industrielles soumis à des contraintes de sécurité strictes."
              />
            </Reveal>
            <Reveal delay={140}>
              <div className="relative mt-9 overflow-hidden rounded-lg bg-primary-950 p-6 text-background-100">
                <div className="pointer-events-none absolute inset-0 paper-grid-dark opacity-50" />
                <div className="pointer-events-none absolute inset-x-0 top-0 h-[3px] bg-accent-500" />
                <div className="relative">
                  <p className="label-mono text-accent-400">Projet hors liste</p>
                  <p className="mt-3 text-sm leading-relaxed text-background-200">
                    Votre secteur n'apparaît pas ? Décrivez-nous votre besoin :
                    <span className="font-semibold text-background-50">
                      {' '}
                      nous étudions chaque projet au cas par cas.
                    </span>
                  </p>
                  <Link
                    to="/contact"
                    className="group mt-5 inline-flex cursor-pointer items-center gap-2 text-xs font-semibold uppercase tracking-[0.16em] text-background-50 transition-colors hover:text-accent-400"
                  >
                    Parler à un technicien
                    <i className="ri-arrow-right-line transition-transform duration-300 group-hover:translate-x-1" />
                  </Link>
                </div>
              </div>
            </Reveal>
          </div>

          <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
            {sectors.map((sector, index) => (
              <Reveal key={sector.title} delay={(index % 2) * 90}>
                <div className="group relative flex h-full cursor-pointer items-center gap-4 overflow-hidden rounded-md border border-foreground-950/10 bg-background-50 px-5 py-6 transition-colors duration-300 hover:border-primary-400">
                  <span className="absolute inset-y-0 left-0 w-[3px] bg-accent-500 opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
                  <span className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-md bg-primary-500 text-background-50 transition-colors duration-300 group-hover:bg-accent-500 group-hover:text-foreground-950">
                    <i className={`${sector.icon} text-xl`} />
                  </span>
                  <div className="min-w-0">
                    <h3 className="font-heading text-lg font-semibold uppercase leading-tight text-foreground-950">
                      {sector.title}
                    </h3>
                    <p className="mt-1 text-[11px] uppercase tracking-[0.14em] text-foreground-500">
                      Travaux &amp; maintenance
                    </p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}